import { useRef } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactComponent as GroupIcon } from '@/assets/icon/group.svg';
import { ReactComponent as BoardIcon } from '@/assets/icon/board.svg';
import { ReactComponent as GraphIcon } from '@/assets/icon/graph2.svg';
import { ReactComponent as RightIcon } from '@/assets/icon/right.svg';
import { ReactComponent as LeftIcon } from '@/assets/icon/left.svg';

import dataVerifierSummaryBg from '../../assets/imgs/home/data_verifier_summary_bg_v2.png';
import seoulMetroBanner from '@/assets/imgs/home/mainSlideBanners_v2/서울교통공사.png';
import korailBanner from '@/assets/imgs/home/mainSlideBanners_v2/한국철도공사.png';
import atBanner from '@/assets/imgs/home/mainSlideBanners_v2/한국농수산유통공사.png';
import molegBanner from '@/assets/imgs/home/mainSlideBanners_v2/법제처.png';
import mlitBanner from '@/assets/imgs/home/mainSlideBanners_v2/국토교통부.png';
import srBanner from '@/assets/imgs/home/mainSlideBanners_v2/에스알.png';
import mohwBanner from '@/assets/imgs/home/mainSlideBanners_v2/행안부.png';
import startupBanner from '@/assets/imgs/home/mainSlideBanners_v2/창업진흥원.png';
import komscoBanner from '@/assets/imgs/home/mainSlideBanners_v2/한국조폐공사.png';
import fscBanner from '@/assets/imgs/home/mainSlideBanners_v2/금융위원회.png';
import mofaBanner from '@/assets/imgs/home/mainSlideBanners_v2/외교부.png';
import ntsBanner from '@/assets/imgs/home/mainSlideBanners_v2/국세청.png';
import nccBanner from '@/assets/imgs/home/mainSlideBanners_v2/국립암센터.png';

import BannerCarousel from '@/components/carousel/BannerCarousel';
import type { BannerProps, BannerCarouselHandle } from '@/components/carousel/BannerCarouselTypes';
import CarouselItem from '@/components/carousel/CarouselItem';
import { Title, TitleBold } from '@/components/common/TextStyle';

const Root = styled(Box)({
  position: 'relative',
  width: '100vw',
  height: '100vh',
  overflow: 'hidden',
});

const GradientBackground = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'linear-gradient(180deg, #3C8EAC 0%, #3483A1 8.17%, #216884 30.77%, #194F5E 53.37%, #143231 90.87%)',
  zIndex: -2,
});

const ImageBackground = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '44vh',
  left: 0,
  width: '100vw',
  height: '378px',
  backgroundImage: `url(${dataVerifierSummaryBg})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '58% center',
  zIndex: -1,
  [theme.breakpoints.up('sm')]: {
    top: 0,
    left: '17.34vw',
    width: '97.34vw',
    height: '103.9vh',
    backgroundPosition: 'center',
  },
}));

const Layout = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '80px',
  height: '100vh',
  paddingLeft: '5.2vw',
  paddingRight: '5.2vw',
  paddingBottom: '5.2vw',
  gap: '3.0vh',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '15px',
    paddingLeft: '4vw',
    paddingRight: '4vw',
    gap: '2.0vh',
  },
}));

const CardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  // justifyContent: 'space-between',
  // flexDirection: 'row',
  flexDirection: 'column',
  // justifyContent: 'center',
  alignContent: 'space-between',
  width: '100%',
  gap: ' 15px',
  // gap: '1vh',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '20px',
    width: '380px',
  },
}));

const StyledCard = styled(Box)(({ theme }) => ({
  // width: '108px',
  // height: '100px',
  width: '95%',
  height: '28%',
  maxHeight: '80px',
  border: '1px solid #FFF',
  // borderRadius: '12px',
  borderRadius: '46px',
  // background: 'rgba(255, 255, 255, 0.10)',
  backdropFilter: 'blur(4px)',
  padding: '10px',
  display: 'flex',
  // flexDirection: 'column',
  flexDirection: 'row',

  alignItems: 'left',
  // gap: '6px',
  gap: '24px',
  [theme.breakpoints.up('sm')]: {
    borderRadius: '46px',
    flexDirection: 'row',
    width: '380px',
    height: '80px',
    gap: '24px',
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  // width: '30px',
  // height: '30px',

  width: '58px',
  height: '58px',
  backgroundColor: 'rgba(16, 12, 12, 0.2)',
  borderRadius: '99px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    // width: '58px',
    // height: '58px',
  },
}));

const styledSvgIcon = (SvgComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>) =>
  styled(SvgComponent)(({ theme }) => ({
    // width: '1.14581rem',
    // height: '1.14581rem',
    width: 'unset',
    height: 'unset',
    [theme.breakpoints.up('sm')]: {
      width: 'unset',
      height: 'unset',
    },
  }));
export const StyledGroupIcon = styledSvgIcon(GroupIcon);
export const StyledBoardIcon = styledSvgIcon(BoardIcon);
export const StyledGraphIcon = styledSvgIcon(GraphIcon);

const CardText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Pretendard',
  // fontWeight: 400,
  fontWeight: 700,
  // fontSize: '11px',
  fontSize: '20px',
  // lineHeight: '14px',
  lineHeight: '28px',
  letterSpacing: 0,
  // textAlign: 'left',
  textAlign: 'center',
  whiteSpace: 'pre-line',
  color: '#ffffff',
  [theme.breakpoints.up('sm')]: {
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28px',
    textAlign: 'center',
  },
}));

const ItemWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: 'auto',
  gap: '0.7vh',
  [theme.breakpoints.up('sm')]: {},
}));

const IconButton = styled('button')(({ theme }) => ({
  width: '30px',
  height: '30px',
  backgroundColor: 'transparent', // 배경 투명으로 변경
  borderRadius: '99px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '2px solid #fff',
  cursor: 'pointer',
  padding: 0,
  // 기본 버튼 스타일 초기화

  [theme.breakpoints.up('sm')]: {
    width: '58px',
    height: '58px',
  },
  '&:hover': {
    outline: '2px solid #fff', // 호버 시에만 아웃라인 보이게
  },
}));

export default function DataVerifierSummary() {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const BannerProps: BannerProps = {
    speed: 4000, // isSmUp ? 8000 : 200,
    autoplay: true, //isSmUp, //boolean값
  };
  const bannerRef = useRef<BannerCarouselHandle>(null);

  return (
    <Root>
      <GradientBackground />
      <ImageBackground />

      <Layout>
        <Box sx={{ flex: { xs: 0.7, sm: 0.9 }, display: 'flex', alignItems: 'flex-end' }}>
          <Title>
            <TitleBold>진위확인 서비스</TitleBold>
            <Title>데이터의 진실을 가장 빠르게,</Title>
            <Title>가장 정확하게 밝혀내는 서비스를{isSmUp ? ' ' : <br />}만들어갑니다.</Title>
          </Title>
        </Box>

        <Box sx={{ flex: 1.2, display: 'flex', alignItems: 'top' }}>
          <CardContainer>
            <StyledCard>
              <IconWrapper>
                <StyledGraphIcon />
              </IconWrapper>
              <CardText>신뢰할 수 있는 출처 기반의{'\n'}정확한 데이터연계</CardText>
            </StyledCard>

            <StyledCard>
              <IconWrapper>
                <StyledBoardIcon />
              </IconWrapper>
              <CardText>Data Infuser 기반{'\n'}실시간 처리와 빠른 응답</CardText>
            </StyledCard>

            <StyledCard>
              <IconWrapper>
                <StyledGroupIcon />
              </IconWrapper>
              <CardText>일일히 조회하지 않아도 되는{'\n'}일괄 처리 지원</CardText>
            </StyledCard>
          </CardContainer>
        </Box>

        <Box
          sx={{
            flex: 0.9,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            justifyContent: { xs: 'center', sm: 'flex-end' },
          }}
        >
          <ItemWrapper>
            <BannerCarousel
              ref={bannerRef}
              settings={BannerProps}
              elements={[
                <CarouselItem imageSrc={seoulMetroBanner} text="서울지하철 실시간 이용정보 서비스" />,
                <CarouselItem imageSrc={korailBanner} text="철도 지연열차 승차권 확인 서비스" />,
                <CarouselItem imageSrc={atBanner} text="전국 도매시장 실시간 경매 및 정산 정보" />,
                <CarouselItem imageSrc={molegBanner} text="특정행정심판 재결례" />,
                <CarouselItem imageSrc={molegBanner} text="중앙부처 법령해석" />,
                <CarouselItem imageSrc={mlitBanner} text="사업용차량 이력정보" />,
                <CarouselItem imageSrc={srBanner} text="SRT 지연승차권 데이터" />,
                <CarouselItem imageSrc={mohwBanner} text="재난배상 책임보험 사업장 정보" />,
                <CarouselItem imageSrc={korailBanner} text="열차운행 및 역무편의시설 정보" />,
                <CarouselItem imageSrc={startupBanner} text="창업지원 및 교육데이터" />,
                <CarouselItem imageSrc={komscoBanner} text="종이형 지역사랑상품권 판매,환전 지점 정보" />,
                <CarouselItem imageSrc={srBanner} text="SRT 회원 현황 정보" />,
                <CarouselItem imageSrc={srBanner} text="SRT 승차권 정보" />,
                <CarouselItem imageSrc={komscoBanner} text="지역사랑상품권 가맹점 정보" />,
                <CarouselItem imageSrc={fscBanner} text="금융공공데이터 중 개인정보사업자 정보" />,
                <CarouselItem imageSrc={korailBanner} text="철도 열차 승차권 진위확인" />,
                <CarouselItem imageSrc={mofaBanner} text="해외안전 융합정보 개방 확대" />,
                <CarouselItem imageSrc={fscBanner} text="금융표준종합정보 DB 개방 확대" />,
                <CarouselItem imageSrc={ntsBanner} text="사업자등록정보 진위확인" />,
                <CarouselItem imageSrc={mofaBanner} text="해외안전 융합정보" />,
                <CarouselItem imageSrc={nccBanner} text="국가 암 병기조사 데이터" />,
              ]}
            />
          </ItemWrapper>
          <Box
            sx={{
              display: { xs: 'flex', sm: 'none' },
              flexDirection: 'row',
              alignContent: 'center',
              justifyContent: 'center',
              gap: '4px',
            }}
          >
            {/* <IconButton onClick={() => bannerRef.current?.prev()}>
              <LeftIcon />
            </IconButton>
            <IconButton onClick={() => bannerRef.current?.next()}>
              <RightIcon />
            </IconButton> */}
          </Box>
        </Box>
      </Layout>
    </Root>
  );
}
